module.exports = __webpack_public_path__ + "img/we1.89fde50a.png";